export default __webpack_public_path__ + "static/media/cargo-1.a0b182af.svg";